import { CONFIG_API } from "@/plugins/axios";
import Vue from "vue";

export class Group {
    constructor(record) {
        if (record) {
            const {
                id,
                name,
                description,
            } = record;
            this.id = id;
            this.name = name;
            this.description = description;
        }
    }
}
export class AccessGroup {
    constructor(record) {
        if (record) {
            const {
                id,
                name,
                description,
                plantsId,
                plants,
                users,
                usersId,
            } = record;
            this.id = id;
            this.name = name;
            this.description = description;
            this.plants = plants ? [...plants] : [];
            this.plantsId = plantsId ? [...plantsId] : [];
            this.users = users ? [...users] : [];
            this.usersId = usersId ? [...usersId] : [];
        }
    }
}

function parseClass(data) {
    let users = [];
    data.forEach(element => {
        let user = new AccessGroup(element);
        users.push(user);
    });
    return users;
}

export async function insertGroup(data) {
    let res;
    try {
        const config = {
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": "JWT " + localStorage.getItem("config_token"),
            }
        };
        res = await CONFIG_API.post("/groups/", data, config);
        return res;
    } catch (error) {
        console.error(error);
    }
}

export async function updateGroup(data) {
    let res = undefined;
    try {
        const config = {
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": "JWT " + localStorage.getItem("config_token"),
            }
        };
        res = await CONFIG_API.put(`/groups/${data.id}/`, data, config);
        return res.status;
    } catch (error) {
        console.warn(error);
    }
    if (res && res.status == 200)
        return res.data;
    return null;
}

export async function removeGroup(id) {
    if (id) {
        try {
            const config = {
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "Authorization": "JWT " + localStorage.getItem("config_token"),
                }
            };
            CONFIG_API.delete(`/groups/${id}/`, config);
        } catch (error) {
            console.error(error);
        }
    }
}

export async function getGroups(params) {
    try {
        const config = {
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": "JWT " + localStorage.getItem("config_token"),
            },
            params: params,
        };
        const res = await CONFIG_API.get("/groups/", config);
        if (params && params.page) {
            if (res && res.status == 200) {
                res.data.results = parseClass(res.data.results);
                return res.data;
            }
            return {
                "links": {
                    "next": null,
                    "previous": null
                },
                "total": 0,
                "page": 0,
                "page_size": 0,
                "results": [
                ]
            };
        } else {
            if (res && res.status == 200)
                return parseClass(res.data);
            return [];
        }
    } catch (error) {
        if (!error.response) return error;
        let { status, data } = error.response;
        let message = "";

        if (data.non_field_errors) {
            message = data.non_field_errors[0];
        }
        return Promise.reject({ status, message });
    }
}


export async function getGroup(id) {
    try {
        const config = {
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": "JWT " + localStorage.getItem("config_token"),
            },
        };
        const res = await CONFIG_API.get(`/groups/${id}/`, config);
        if (res.status == 200) {
            return res.data;
        }
    } catch (error) {
        if (!error.response) return error;
        let { status, data } = error.response;
        let message = "";
        if (data.non_field_errors) {
            message = data.non_field_errors[0];
        }
        return Promise.reject({ status, message });
    }
}




export async function getGroupsUsers(params) {
    try {
        const config = {
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": "JWT " + localStorage.getItem("config_token"),
            },
            params: params,
        };
        const res = await CONFIG_API.get("/group-users/", config);
        if (res.status == 200) {
            return res.data;
        }
    } catch (error) {
        if (!error.response) return error;
        let { status, data } = error.response;
        let message = "";
        if (data.non_field_errors) {
            message = data.non_field_errors[0];
        }
        return Promise.reject({ status, message });
    }
}
export async function insertGroupUser(data) {
    let res;
    try {
        const config = {
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": "JWT " + localStorage.getItem("config_token"),
            }
        };
        res = await CONFIG_API.post("/group-users/", data, config);
        return res;
    } catch (error) {
        console.error(error);
    }
}
export async function removeGroupUser(id) {
    if (id) {
        try {
            const config = {
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "Authorization": "JWT " + localStorage.getItem("config_token"),
                }
            };
            CONFIG_API.delete(`/group-users/${id}/`, config);
        } catch (error) {
            console.error(error);
        }
    }
}

export async function getGroupsPlants(params) {
    try {
        const config = {
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": "JWT " + localStorage.getItem("config_token"),
            },
            params: params,
        };
        const res = await CONFIG_API.get("/group-plants/", config);
        if (res.status == 200) {
            return res.data;
        }
    } catch (error) {
        if (!error.response) return error;
        let { status, data } = error.response;
        let message = "";
        if (data.non_field_errors) {
            message = data.non_field_errors[0];
        }
        return Promise.reject({ status, message });
    }
}

export async function insertGroupPlant(data) {
    let res;
    try {
        const config = {
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": "JWT " + localStorage.getItem("config_token"),
            }
        };
        res = await CONFIG_API.post("/group-plants/", data, config);
        return res;
    } catch (error) {
        console.error(error);
    }
}
export async function removeGroupPlant(id) {
    if (id) {
        try {
            const config = {
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "Authorization": "JWT " + localStorage.getItem("config_token"),
                }
            };
            CONFIG_API.delete(`/group-plants/${id}/`, config);
        } catch (error) {
            console.error(error);
        }
    }
}

export async function mountUserConnections(groupCons) {
    let newFormat = {};
    groupCons.forEach(conn => {
        if (!newFormat[conn.group]) {
            Vue.set(newFormat, conn.group, {
                id: conn.group,
                // usersId: new Set(),
            });
        }
    // newFormat[conn.group].usersId.add(conn.user)
    });
    let response = [];
    /**
   * TODO: 
   *  Implement a way to make only one request for each type
   */
    for (const key in newFormat) {
        const group = await getGroup(key);
        const plant_conns = await getGroupsPlants({ group: key });
        let plantsId = plant_conns.map(e => e.plant);
        Vue.set(newFormat[key], "plantsId", plantsId);
        Vue.set(newFormat[key], "name", group.name);
        Vue.set(newFormat[key], "description", group.description);
        response.push(new AccessGroup(newFormat[key]));
    }
    return response;
}

export async function getCurrentUserGroups() {
    try {
        const config = {
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": "JWT " + localStorage.getItem("config_token"),
            },
        };
        const res = await CONFIG_API.get("/group-users/get_current_user_groups/", config);
        if (res.status == 200) {
            let connections = [...res.data];
            connections = await mountUserConnections(connections);
            return connections;
        }
    } catch (error) {
        if (!error.response) return error;
        let { status, data } = error.response;
        let message = "";
        if (data.non_field_errors) {
            message = data.non_field_errors[0];
        }
        return Promise.reject({ status, message });
    }
}


// vai que né
export async function getUserGroupsConnections(params) {
    try {
        const config = {
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": "JWT " + localStorage.getItem("config_token"),
            },
            params: params,
        };
        const res = await CONFIG_API.get("/group-users/", config);
        if (res.status == 200) {
            let connections = [...res.data];
            connections = mountUserConnections(connections);
            return connections;
        }
    } catch (error) {
        if (!error.response) return error;
        let { status, data } = error.response;
        let message = "";
        if (data.non_field_errors) {
            message = data.non_field_errors[0];
        }
        return Promise.reject({ status, message });
    }
}